import '@/coalitions/locations-map';
import CC from '@/cc';

(function() {

  var $self = this;
  $self.Coalitions           = $self.Coalitions           || {};
  $self.Coalitions.locations = $self.Coalitions.locations || {};

  $self.Coalitions.locations.init = function() {
    $self.Coalitions.locations.map.init();
  };

}).call(CC);

CC.Coalitions.locations.init();
